const NAME_POOLS = [
  {
    tags: ['sweet', 'japanese', 'gentle'],
    description: 'feels like wagashi-inspired sweets—perfect for cream-toned cuddle bugs.',
    names: [
      'Mochiko',
      'Kinako',
      'Dango',
      'Anko',
      'Sakura Mochi',
      'Botamochi',
      'Taiyaki',
      'Dorayaki',
      'Warabi',
      'Anmitsu',
      'Mizu Yokan',
      'Yatsuhashi',
      'Kuri Puff',
      'Castella',
      'Matcha Soufflé',
      'Butter Mochi',
      'Yuzu Puff',
      'Kuzu Jelly',
      'Monaka',
      'Kinomi'
    ]
  },
  {
    tags: ['sweet', 'european', 'regal'],
    description: 'carries a patisserie softness with an elegant, celebratory tone.',
    names: [
      'Chouquette',
      'Millefeuille',
      'Macaron',
      'Éclair',
      'Financier',
      'Madeleine',
      'Galette',
      'Soufflé',
      'Tiramisu',
      'Cannoli',
      'Gelato',
      'Pavlova',
      'Canelé',
      'Kouign',
      'Marzipan',
      'Nougat',
      'Truffle',
      'Panna Cotta',
      'Viennois',
      'Crème Brûlée'
    ]
  },
  {
    tags: ['floral', 'gentle', 'daydream'],
    description: 'brings a botanical calm, like petals caught in a daydream breeze.',
    names: [
      'Peony',
      'Camellia',
      'Wisteria',
      'Magnolia',
      'Clover',
      'Marigold',
      'Bluebell',
      'Lotus',
      'Iris',
      'Gardenia',
      'Primrose',
      'Thistle',
      'Willow',
      'Juniper',
      'Hazel',
      'Maple Bloom',
      'Velvet Moss',
      'Moon Laurel',
      'Silver Fern',
      'Petal Drift'
    ]
  },
  {
    tags: ['celestial', 'mystic', 'night'],
    description: 'full of moonlight and stardust energy for night-loving buns.',
    names: [
      'Moonbeam',
      'Selene',
      'Tsukimi',
      'Hoshiko',
      'Aurora',
      'Nebula',
      'Stardust',
      'Polaris',
      'Luna Nova',
      'Comet Tail',
      'Eclipse',
      'Nocturne',
      'Galaxie',
      'Mercury Mist',
      'Midnight Bloom',
      'Starlet',
      'Solstice',
      'Celeste Ember',
      'Opal Nova',
      'Comet Peach'
    ]
  },
  {
    tags: ['folklore', 'japanese', 'poetic'],
    description: 'pulled from Japanese folklore and moon-rabbit tales.',
    names: [
      'Kintsugi',
      'Origami',
      'Hikari',
      'Midori',
      'Umami',
      'Kumo',
      'Nori',
      'Miyuki',
      'Akari',
      'Kohaku',
      'Suzu',
      'Kaguya',
      'Fuyu',
      'Kasumi',
      'Rinrin',
      'Satsuki',
      'Ayame',
      'Nazuna',
      'Mika',
      'Yukine'
    ]
  },
  {
    tags: ['woodland', 'playful', 'earthy'],
    description: 'whispers of hillside cottages—playful with an earthy warmth.',
    names: [
      'Cloverleaf',
      'Briar',
      'Linden',
      'Mallow',
      'Mossy',
      'Thimble',
      'Acorn',
      'Pipkin',
      'Bracken',
      'Thistledew',
      'Evergreen',
      'Hearth',
      'Hickory',
      'Driftwood',
      'Russet',
      'Pecan',
      'Honeydew',
      'Meadowlark',
      'Whimsy',
      'Pumpkin Seed'
    ]
  },
  {
    tags: ['modern', 'minimal', 'bold'],
    description: 'minimal, slightly futuristic lines for city-dwelling rabbits.',
    names: [
      'Pixel',
      'Nova Bean',
      'Miso',
      'Sumi',
      'Quill',
      'Indigo',
      'Cirrus',
      'Nimbus',
      'Lumen',
      'Echo',
      'Slate',
      'Velvet',
      'Sable',
      'Carbon',
      'Orbit',
      'Lo-Fi',
      'Mono',
      'Sol',
      'Atlas',
      'Halo'
    ]
  }
];

const NAME_LIBRARY = NAME_POOLS.flatMap((pool) =>
  pool.names.map((name) => ({
    name,
    tags: [...pool.tags],
    description: `${name} ${pool.description}`
  }))
);

const FILTER_GROUPS = [
  {
    label: 'Vibe',
    tags: [
      { id: 'gentle', label: 'Soft & soothing' },
      { id: 'playful', label: 'Playful energy' },
      { id: 'regal', label: 'Regal & polished' },
      { id: 'mystic', label: 'Mystic dreamer' },
      { id: 'bold', label: 'Bold minimal' }
    ]
  },
  {
    label: 'Inspiration',
    tags: [
      { id: 'sweet', label: 'Dessert' },
      { id: 'floral', label: 'Garden' },
      { id: 'celestial', label: 'Moonlight' },
      { id: 'folklore', label: 'Folklore' },
      { id: 'woodland', label: 'Woodland' },
      { id: 'modern', label: 'Modern' }
    ]
  },
  {
    label: 'Cultural cues',
    tags: [
      { id: 'japanese', label: 'Japanese' },
      { id: 'european', label: 'European' },
      { id: 'daydream', label: 'Daydream' },
      { id: 'night', label: 'Night' },
      { id: 'earthy', label: 'Earthy' },
      { id: 'minimal', label: 'Minimal' }
    ]
  }
];

const state = {
  selectedTags: new Set(),
  currentEntry: null
};

const elements = {
  chipContainer: document.querySelector('[data-chip-container]'),
  selectionNote: document.querySelector('[data-selection-note]'),
  primaryName: document.querySelector('[data-name-result]'),
  nameDescription: document.querySelector('[data-name-description]'),
  status: document.querySelector('[data-name-status]'),
  reroll: document.querySelector('[data-reroll]'),
  copy: document.querySelector('[data-copy-name]'),
  nameCardLink: document.querySelector('[data-name-card-link]'),
  suggestionList: document.querySelector('[data-suggestion-list]'),
  seoList: document.querySelector('[data-seo-list]')
};

function renderFilterChips() {
  if (!elements.chipContainer) return;
  const fragment = document.createDocumentFragment();

  FILTER_GROUPS.forEach((group) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'chip-group';
    const label = document.createElement('p');
    label.className = 'chip-label';
    label.textContent = group.label;
    const chipsRow = document.createElement('div');
    chipsRow.className = 'chip-row';
    group.tags.forEach((tag) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'chip';
      button.dataset.tag = tag.id;
      button.textContent = tag.label;
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => toggleTag(tag.id, button));
      chipsRow.appendChild(button);
    });
    wrapper.append(label, chipsRow);
    fragment.appendChild(wrapper);
  });

  elements.chipContainer.innerHTML = '';
  elements.chipContainer.appendChild(fragment);
}

function toggleTag(tag, button) {
  if (state.selectedTags.has(tag)) {
    state.selectedTags.delete(tag);
    button?.setAttribute('aria-pressed', 'false');
    button?.classList.remove('is-active');
  } else {
    state.selectedTags.add(tag);
    button?.setAttribute('aria-pressed', 'true');
    button?.classList.add('is-active');
  }
  updateSelectionNote();
  pickRandomName();
}

function updateSelectionNote() {
  if (!elements.selectionNote) return;
  if (!state.selectedTags.size) {
    elements.selectionNote.textContent = 'No tags selected — pulling from the entire Cute rabbit names list.';
    return;
  }
  const tags = Array.from(state.selectedTags)
    .map((tag) => FILTER_GROUPS.flatMap((g) => g.tags).find((item) => item.id === tag)?.label || tag)
    .join(' · ');
  elements.selectionNote.textContent = `Filters applied: ${tags}`;
}

function getFilteredNames() {
  if (!state.selectedTags.size) return NAME_LIBRARY;
  return NAME_LIBRARY.filter((entry) => {
    for (const tag of state.selectedTags) {
      if (!entry.tags.includes(tag)) return false;
    }
    return true;
  });
}

function pickRandomName() {
  const pool = getFilteredNames();
  if (!pool.length) {
    setStatus('No names match those tags—remove one filter to unlock more ideas.', true);
    return;
  }
  const randomIndex = Math.floor(Math.random() * pool.length);
  const entry = pool[randomIndex];
  state.currentEntry = entry;
  renderPrimaryName(entry);
  renderSuggestions(pool, entry.name);
  setStatus(`Chosen from ${pool.length} cute rabbit names that match your filters.`);
}

function renderPrimaryName(entry) {
  if (!elements.primaryName || !elements.nameDescription) return;
  elements.primaryName.textContent = entry.name;
  elements.nameDescription.textContent = entry.description;
  if (elements.nameCardLink) {
    const params = new URLSearchParams();
    params.set('name', entry.name);
    params.set('tags', entry.tags.join(','));
    elements.nameCardLink.href = `rabbit-name-card.html?${params.toString()}`;
  }
}

function renderSuggestions(pool, excludeName) {
  if (!elements.suggestionList) return;
  const shuffled = pool
    .filter((entry) => entry.name !== excludeName)
    .sort(() => Math.random() - 0.5)
    .slice(0, 6);
  elements.suggestionList.innerHTML = '';
  if (!shuffled.length) {
    const li = document.createElement('li');
    li.textContent = 'Adjust filters to unlock more names.';
    elements.suggestionList.appendChild(li);
    return;
  }
  shuffled.forEach((entry) => {
    const li = document.createElement('li');
    li.innerHTML = `<strong>${entry.name}</strong><span>${entry.tags.join(' · ')}</span>`;
    li.addEventListener('click', () => {
      state.currentEntry = entry;
      renderPrimaryName(entry);
      renderSuggestions(pool, entry.name);
    });
    elements.suggestionList.appendChild(li);
  });
}

function handleCopy() {
  if (!state.currentEntry) return;
  navigator.clipboard
    .writeText(state.currentEntry.name)
    .then(() => setStatus(`Copied ${state.currentEntry.name}! Paste it wherever you like.`))
    .catch(() => setStatus('Clipboard blocked—please copy the name manually.', true));
}

function setStatus(message, isError = false) {
  if (!elements.status) return;
  elements.status.textContent = message;
  elements.status.classList.toggle('error', Boolean(isError));
}

function populateSeoList() {
  if (!elements.seoList) return;
  const mixture = NAME_LIBRARY.sort(() => Math.random() - 0.5).slice(0, 12);
  elements.seoList.innerHTML = '';
  mixture.forEach((entry) => {
    const li = document.createElement('li');
    li.textContent = entry.name;
    elements.seoList.appendChild(li);
  });
}

function initControls() {
  elements.reroll?.addEventListener('click', () => pickRandomName());
  elements.copy?.addEventListener('click', handleCopy);
}

function init() {
  renderFilterChips();
  populateSeoList();
  initControls();
  updateSelectionNote();
  pickRandomName();
}

init();
